/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { useParams } from "react-router-dom";
import AddContact from "./AddContact";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import { useGetContactQuery } from "../store/slices/contactsSlice";
import Logs from "../Dashboard/Logs";
import LogsIcon from "../../assets/icons/billing_overview.svg2";

export default function ContactEditPage() {
  const params = useParams();

  const {
    data: contact = { status: "active", details: [] },
    isLoading: loading,
  } = useGetContactQuery(
    {
      contactUuid: params.contactUUID,
      isAllFields: true,
    },
    { skip: !params.contactUUID }
  );

  console.log(params);

  return (
    <div>
      <FullScreenLoadingIndicator loading={loading} />
      {!loading &&
        (contact?.uuid || !params.contactUUID ? (
          <AddContact key={contact?.uuid} editedContact={contact} />
        ) : (
          <div className="alert alert-danger text-center">
            Contact not found
          </div>
        ))}
      {params.contactUUID && (
        <>
          <h5 className="mt-5">
            <LogsIcon width={30} className="me-2" />
            Logs
          </h5>
          <hr className="my-3 text-secondary" />
          <div className="p-3 bg-white rounded-3">
            <Logs
              kind="contact"
              resource={contact?.uuid || params.contactUUID}
            />
          </div>
        </>
      )}
    </div>
  );
}
